import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
// import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import { useDemoData } from '@mui/x-data-grid-generator';
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../../../../components/datatable/AppDataGrid';
import FetchApi from '../../../../customhooks/Functionapi';
import Stepflow from '../../document/stepflow';
import PopUpViewFlowstatus from '../../viewflowprocess/PopUpViewFlowstatus';
import PopUpChangeFlow from './popUpChangeFlow';
import { Container } from '@mui/material';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { GridActions, ActionPopup } from '../../../../../components/datatable/GridActions';
//  <PopUpViewFlowstatus jourId={params.row.JournalID} />
// import 


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const PopUpRecall = (props) => {

    const FetchApis = new FetchApi();
    const [datalist, setDatalist] = useState([])
    const[searhText,setSeahrText]=useState([])

    const { data, loading } = useDemoData({
        dataSet: 'Commodity',
        rowLength: 10,
        maxColumns: 6,
    });

    useEffect(() => {
        getlistrecall(props.userId)
    }, [])

    function getlistrecall(Iduser) {
        FetchApis.FethcGet(`/document/DocumentApprovedlist/${Iduser}`).then(res => {

            if (res.status == 200) {
                setDatalist(res.data);
                setSeahrText(res.data)
               
            }

        })
    }


    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function getRowId(row) {
        return row.JournalID;
    }


    const columns = [
        { field: 'num', headerName: 'NO', width: 90 },
        {
            field: 'JournalCode',
            headerName: 'Journal Code',
            width: 150,
            editable: true,
            renderCell: (params) => (
                <span style={{ fontWeight: 600, color: '#1565c0' }}>{params.value}</span>
            ),
        },
        {
            field: 'TransDate',
            headerName: 'TransDate',
            width: 150,
            editable: true,
        },
        {
            field: 'ItemTypeID',
            headerName: 'ItemTypeID',
            // type: 'number',
            width: 150,
            editable: true,
        },
        // {
        //     field: 'CustID',
        //     headerName: 'CustID',
        //     // type: 'number',
        //     width: 150,
        //     editable: true,
        // },
        // {
        //     field: 'ItemID',
        //     headerName: 'ItemID',
        //     // type: 'number',
        //     width: 110,
        //     editable: true,
        // },
        {
            field: 'flowdetail',
            headerName: 'Flow detail',
            // type: 'number',
            width: 150,
            editable: true,
        },
        {
            field: 'Processflow',
            headerName: 'Process flow',
            sortable: false,
            width: 200,
            renderCell: (params) => {
                return (
                    <div style={{ flexDirection: 'row', alignContent: 'space-between', display: 'flex', width: 300 }}>
                        <Stepflow stateflow={params.row.stateflow} endstateflow={params.row.frstateflow}
                            statusflow={params.row.statusflow}
                            activerecieved={params.row.activerecieved}
                            activeapproved={params.row.activeapproved}
                        />
                    </div>
                )
            }

        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 230,
            minWidth: 230,
            sortable: false,
            cellClassName: 'actions',
            renderCell: (params) => {
                return (
                    <GridActions>
                        <ActionPopup tone="flow"><PopUpViewFlowstatus jourId={params.row.JournalID} /></ActionPopup>
                        <ActionPopup tone="edit"><PopUpChangeFlow jourId={params.row.JournalID} /></ActionPopup>
                    </GridActions>
                )
            }
        }
    ];

    const isSearchText=(e)=>{
        const query = e.target.value;

        const filteredData = searhText.filter(item => {
            return Object.values(item)
                .join('')
                .toLowerCase()
                .includes(query.toLowerCase());
        });

        setDatalist(filteredData);


    }


    return (
        <div>
            <React.Fragment>
                <div>
                    <Button variant="outlined" onClick={handleClickOpen} startIcon={<SwapHorizRoundedIcon />}
                        sx={{ height: 38, px: 2, borderRadius: 999, textTransform: 'none', fontWeight: 600, fontSize: 13.5,
                            borderColor: '#c5cae9', color: '#3949ab', bgcolor: '#fff',
                            '&:hover': { borderColor: '#3949ab', bgcolor: '#3949ab0f' } }}>
                        Change Flow
                    </Button>
                </div>

                <Dialog
                    fullScreen
                    open={open}
                    onClose={handleClose}
                    slots={{
                        transition: Transition,
                    }}
                >
                    <AppBar elevation={0} sx={{ position: 'relative',
                        background: 'linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)' }}>
                        <Toolbar sx={{ gap: 1.5, minHeight: { xs: 64, sm: 72 } }}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Avatar sx={{ bgcolor: 'rgba(255,255,255,.18)', width: 40, height: 40 }}>
                                <SwapHorizRoundedIcon />
                            </Avatar>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography variant="h6" component="div" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
                                    Change Flow
                                </Typography>
                                <Typography sx={{ fontSize: 13, opacity: .85 }} noWrap>
                                    เปลี่ยนลำดับผู้อนุมัติของเอกสารที่อยู่ระหว่างดำเนินการ
                                </Typography>
                            </Box>
                            <Button autoFocus color="inherit" onClick={handleClose} startIcon={<CloseIcon />}
                                sx={{ borderRadius: 999, px: 2, textTransform: 'none', fontWeight: 600,
                                    bgcolor: 'rgba(255,255,255,.12)', '&:hover': { bgcolor: 'rgba(255,255,255,.22)' } }}>
                                ปิด
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f4f6f9', flex: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            flexWrap: 'wrap', gap: 1.5, mb: 2 }}>
                            <TextField
                                size="small"
                                name="textsearch"
                                placeholder="ค้นหา Journal Code, ประเภท, Flow..."
                                onChange={(e) => isSearchText(e)}
                                sx={{ width: { xs: '100%', sm: 380 }, bgcolor: '#fff', borderRadius: 2,
                                    '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                InputProps={{ startAdornment: (
                                    <InputAdornment position="start"><SearchRoundedIcon sx={{ color: '#90a4ae' }} /></InputAdornment>
                                ) }}
                            />
                            <Chip icon={<DescriptionOutlinedIcon />} label={`ทั้งหมด ${datalist.length} รายการ`}
                                sx={{ bgcolor: '#e3f0fd', color: '#1565c0', fontWeight: 600,
                                    '& .MuiChip-icon': { color: '#1565c0' } }} />
                        </Box>
                        <AppDataGrid
                            rows={datalist}
                            getRowId={getRowId}
                            columns={columns}
                            loading={loading}
                            slots={{ toolbar: GridToolbar }}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 25,
                                    },
                                },
                            }}
                            pageSizeOptions={[10, 25, 50, 100]}
                        />
                    </Box>
                </Dialog>
            </React.Fragment>
        </div>
    )
}

export default PopUpRecall
